import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import { getDirection } from "./utilities";
import { useLocale } from "../../../hooks/useLocale/useLocale";

const Head = () => {
  const locale = useLocale();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale); // Update i18next language
    }
  }, [locale, i18n]);

  const direction = getDirection(locale);

  return (
    <Helmet>
      <html dir={direction} lang={locale} />
    </Helmet>
  );
};

export default React.memo(Head);
